import {cloneDeep, random, includes, assign} from 'lodash'
import defaultBranding from '../defaultBranding'
import { getWhiteLabelData as getData, getLogo } from '../ALIANZA_API_V2'
import alianzaLogo from './alianza-white-logo.png'

class WhiteLabelClass {
  constructor () {
    this.whiteLabel = whiteLabel()
  }
  getWhiteLabelData () {
    return this.whiteLabel
  }
}

const whiteLabelData = new WhiteLabelClass()
export default whiteLabelData

function whiteLabel () {
  // const alianzaLogo = require('./logo.png')
  let stylesEl
  const className = 'white-label_class' + random(1, 900000)
  const whiteLabel = {
    logo: alianzaLogo,
    data: cloneDeep(defaultBranding),
    init,
    changeStyles,
    resetStyles,
    primaryIsDark: false
  }

  return whiteLabel

  function init () {
    return fetchWhiteLabelData().then(addStyles).catch(() => {
    })
  }

  function changeStyles (data, logo) {
    whiteLabel.logo = logo || getLogo(data.subDomain, alianzaLogo)
    const newData = { ...data }
    if (newData.linkColor === '' || !newData.linkColor) {
      newData.linkColor = whiteLabel.data.linkColor
    }
    addStyles(newData)
  }

  function resetStyles () {
    const domain = window.serverConfig.subDomain || window.location.hostname
    whiteLabel.logo = getLogo(domain, alianzaLogo)
    addStyles(whiteLabel.data)
  }

  function fetchWhiteLabelData () {
    const domain = window.serverConfig.subDomain || window.location.hostname
    if (!includes(domain, 'user') || whiteLabel.data.subDomain === domain) {
      return Promise.resolve(whiteLabel.data)
    }
    // case where we get the value async
    whiteLabel.logo = getLogo(domain, alianzaLogo)
    return getData(domain)
      .then(res => {
        assign(whiteLabel.data, res.data)
        return whiteLabel.data
      })
      .catch(() => {
        // default back to our styles
        whiteLabel.logo = alianzaLogo
        return whiteLabel.data
      })
  }

  function addStyles (data) {
    const body = document.querySelector('body')
    let elId = body.getAttribute('id')
    if (!elId) {
      elId = 'white-label_id' + random(1, 900000)
      body.setAttribute('id', elId)
    }
    body.classList.add(className)

    const styles = getStyles(elId, data)
    if (stylesEl) {
      stylesEl.remove()
    }
    stylesEl = document.createElement('style')
    stylesEl.type = 'text/css'
    if (stylesEl.styleSheet) {
      stylesEl.styleSheet.cssText = styles
    } else {
      stylesEl.appendChild(document.createTextNode(styles))
    }

    document.head.appendChild(stylesEl)

    const themeMeta = document.querySelector('meta[name="theme-color"]')
    if (themeMeta) {
      document.head.removeChild(themeMeta)
    }
    const newMetaEl = document.createElement('meta')
    newMetaEl.name = 'theme-color'
    newMetaEl.content = data.mainColor
    document.head.appendChild(newMetaEl)
    // devLog.info('appended styles for ', data)
    return data
  }

  function getStyles (id, { mainColor, primaryColor, linkColor }) {
    const prefix = `#${id}.${className}`

    return `
      ${prefix} .header-bar {
        background-color: ${primaryColor};
      }

      ${prefix} .page-title {
        color: ${linkColor};
      }
    `
  }
}



// WEBPACK FOOTER //
// ./src/lib/whiteLabel/whiteLabel.js